import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 py-3" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("h4", { class: "m-0" }, "Ubah Status Pembayaran"),
  /*#__PURE__*/_createVNode("small", { class: "text-muted" }, "Gunakan cheat ini untuk ubah tanggal pembayaran")
], -1)
const _hoisted_9 = { class: "form-check form-switch mt-1 ms-5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, "Bulk Mode", -1)
const _hoisted_11 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "cheat1-user" }, "Nomor Invoice", -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "cheat1-status" }, "Status", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "330" }, "ORDER_SUCCESS", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", { value: "331" }, "ORDER_SUCCESS_MANUAL", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("option", { value: "341" }, "ORDER_EXPIRED", -1)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "cheat1-date" }, [
  /*#__PURE__*/_createTextVNode("Tanggal Pembayaran "),
  /*#__PURE__*/_createVNode("small", null, "(Kosongkan jika tidak berubah)")
], -1)
const _hoisted_21 = {
  key: 3,
  class: "flex-grow-1 me-5"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "cheat1-bulk" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Gunakan format "),
    /*#__PURE__*/_createVNode("code", null, "<no invoice>,<status SUCCESS/MANUAL/EXPIRED>,<datetime dd-mm-yyyy_hh:ii>"),
    /*#__PURE__*/_createTextVNode(" dan pisahkan dengan baris baru")
  ]),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, " format tanggal 24 jam (tambahkan detik jika diperlukan) dan jika tanggal tidak dirubah, kosongkan bagian datetime dengan tetap menggunakan tanda koma "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Contoh:"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, [
      /*#__PURE__*/_createTextVNode(" 123456-123,MANUAL,31-01-2021_20:56:43"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" 456789-456,SUCCESS,24-07-2022_15:30"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" 789012-789,EXPIRED, ")
    ])
  ])
], -1)
const _hoisted_23 = { class: "row mb-3" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "card h-100" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12 py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
    /*#__PURE__*/_createVNode("h4", { class: "m-0" }, "Resend Callback Mrkrabs")
  ])
], -1)
const _hoisted_30 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_31 = { class: "flex-grow-1 me-5" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "cheat2-bulk" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "Gunakan order id dan pisahkan dengan koma"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Contoh:"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, " 1234567890,4567890123,7890123456 ")
  ])
], -1)
const _hoisted_33 = { class: "row mb-3" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "card h-100" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-12 py-3" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
    /*#__PURE__*/_createVNode("h4", { class: "m-0" }, "Hapus Invoice Terbayar")
  ])
], -1)
const _hoisted_40 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_41 = { class: "flex-grow-1 me-5" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { for: "cheat3-bulk" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "Gunakan nomor invoice dan pisahkan dengan koma"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Contoh:"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, " 123456-123,456789-456,789012-789 ")
  ])
], -1)
const _hoisted_43 = { class: "row mb-3" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "card h-100" }
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-12 py-3" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
    /*#__PURE__*/_createVNode("h4", { class: "m-0" }, "Reactivate Expired Order")
  ])
], -1)
const _hoisted_50 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_51 = { class: "flex-grow-1 me-5" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { for: "cheat4-bulk" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "Gunakan order id dan pisahkan dengan koma (hanya bisa digunakan selain Xendit dan Midtrans)"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Contoh:"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, " 1234567890,4567890123,7890123456 ")
  ])
], -1)
const _hoisted_53 = { class: "row mb-3" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "card h-100" }
const _hoisted_56 = { class: "card-body" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-12 py-3" }
const _hoisted_59 = { class: "d-flex" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("h4", { class: "m-0" }, "Pindah Pembayaran"),
  /*#__PURE__*/_createVNode("small", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode(" Pindahkan invoice terbayar ke tagihan yang lain"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, "Pastikan invoice bukan multipayment")
  ])
], -1)
const _hoisted_61 = { class: "form-check form-switch mt-1 ms-5" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, "Bulk Mode", -1)
const _hoisted_63 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createVNode("label", { for: "cheat5-user" }, [
  /*#__PURE__*/_createTextVNode(" Pindahkan invoice berikut :"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("small", null, "Masukkan nomor invoice")
], -1)
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", { for: "cheat5-user" }, [
  /*#__PURE__*/_createTextVNode(" Ke tagihan berikut :"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("small", null, "Masukkan id tagihan")
], -1)
const _hoisted_68 = {
  key: 2,
  class: "flex-grow-1 me-5"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("label", { for: "cheat5-bulk" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Gunakan format "),
    /*#__PURE__*/_createVNode("code", null, "<no invoice>,<Id Tagihan xxx-xx-xx>"),
    /*#__PURE__*/_createTextVNode(" dan pisahkan dengan baris baru")
  ]),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Contoh:"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, [
      /*#__PURE__*/_createTextVNode(" 123456-123,99-87-7"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" 456789-456,123-34-12"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" 789012-789,12-34-1 ")
    ])
  ])
], -1)
const _hoisted_70 = { class: "row mb-3" }
const _hoisted_71 = { class: "col" }
const _hoisted_72 = { class: "card h-100" }
const _hoisted_73 = { class: "card-body" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-12 py-3" }
const _hoisted_76 = { class: "d-flex" }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("h4", { class: "m-0" }, "Ubah Nominal Terbayar"),
  /*#__PURE__*/_createVNode("small", { class: "text-muted" }, [
    /*#__PURE__*/_createVNode("code", null, "bisa untuk invoice multipayment")
  ])
], -1)
const _hoisted_78 = { class: "form-check form-switch mt-1 ms-5" }
const _hoisted_79 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, "Bulk Mode", -1)
const _hoisted_80 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { for: "cheat6-user" }, " Nomor Invoice ", -1)
const _hoisted_83 = { key: 1 }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { for: "cheat6-user" }, " Nominal ", -1)
const _hoisted_85 = {
  key: 2,
  class: "flex-grow-1 me-5"
}
const _hoisted_86 = /*#__PURE__*/_createVNode("label", { for: "cheat6-bulk" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Gunakan format "),
    /*#__PURE__*/_createVNode("code", null, "<no invoice>,<nominal>"),
    /*#__PURE__*/_createTextVNode(" dan pisahkan dengan baris baru")
  ]),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Contoh:"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("code", null, [
      /*#__PURE__*/_createTextVNode(" 123456-123,5000000"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" 456789-456,450000"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" 789012-789,150000 ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Cheat Panel",
      link1: "Cheat Panel"
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("div", _hoisted_9, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cheat1.bulkMode = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.cheat1.bulkMode]
                    ]),
                    _hoisted_10
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  (!_ctx.cheat1.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          id: "cheat1-user",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cheat1.invoice_no = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.cheat1.invoice_no]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.cheat1.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createVNode("select", {
                          id: "cheat1-status",
                          class: "form-select form-select-sm",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cheat1.status = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => {if (_ctx.cheat1.status == 341) { _ctx.cheat1.payment_date = ''; }})
                        }, [
                          _hoisted_16,
                          _hoisted_17,
                          _hoisted_18
                        ], 544), [
                          [_vModelSelect, _ctx.cheat1.status]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.cheat1.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _withDirectives(_createVNode("input", {
                          type: "datetime-local",
                          id: "cheat1-date",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.cheat1.payment_date = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.cheat1.payment_date]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.cheat1.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createVNode("textarea", {
                          id: "cheat1-bulk",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.cheat1.bulk = $event)),
                          rows: "5"
                        }, null, 512), [
                          [_vModelText, _ctx.cheat1.bulk]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cheat1Submit && _ctx.cheat1Submit(...args)))
                    }, "Submit")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createVNode("textarea", {
                      id: "cheat2-bulk",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.cheat2.order_ids = $event)),
                      rows: "5"
                    }, null, 512), [
                      [_vModelText, _ctx.cheat2.order_ids]
                    ])
                  ]),
                  _createVNode("div", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cheat2Submit && _ctx.cheat2Submit(...args)))
                    }, "Submit")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      _createVNode("div", _hoisted_34, [
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _withDirectives(_createVNode("textarea", {
                      id: "cheat3-bulk",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.cheat3.invoice_nos = $event)),
                      rows: "5"
                    }, null, 512), [
                      [_vModelText, _ctx.cheat3.invoice_nos]
                    ])
                  ]),
                  _createVNode("div", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cheat3Submit && _ctx.cheat3Submit(...args)))
                    }, "Submit")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_43, [
      _createVNode("div", _hoisted_44, [
        _createVNode("div", _hoisted_45, [
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createVNode("textarea", {
                      id: "cheat4-bulk",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.cheat4.order_ids = $event)),
                      rows: "5"
                    }, null, 512), [
                      [_vModelText, _ctx.cheat4.order_ids]
                    ])
                  ]),
                  _createVNode("div", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cheat4Submit && _ctx.cheat4Submit(...args)))
                    }, "Submit")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_53, [
      _createVNode("div", _hoisted_54, [
        _createVNode("div", _hoisted_55, [
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, [
                _createVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode("div", _hoisted_61, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.cheat5.bulkMode = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.cheat5.bulkMode]
                    ]),
                    _hoisted_62
                  ])
                ]),
                _createVNode("div", _hoisted_63, [
                  (!_ctx.cheat5.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_64, [
                        _hoisted_65,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          id: "cheat5-user",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.cheat5.invoice_no = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.cheat5.invoice_no]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.cheat5.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_66, [
                        _hoisted_67,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          id: "cheat5-user",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.cheat5.bill_id = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.cheat5.bill_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.cheat5.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_68, [
                        _hoisted_69,
                        _withDirectives(_createVNode("textarea", {
                          id: "cheat5-bulk",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.cheat5.bulk = $event)),
                          rows: "5"
                        }, null, 512), [
                          [_vModelText, _ctx.cheat5.bulk]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cheat5Submit && _ctx.cheat5Submit(...args)))
                    }, "Submit")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_70, [
      _createVNode("div", _hoisted_71, [
        _createVNode("div", _hoisted_72, [
          _createVNode("div", _hoisted_73, [
            _createVNode("div", _hoisted_74, [
              _createVNode("div", _hoisted_75, [
                _createVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode("div", _hoisted_78, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.cheat6.bulkMode = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.cheat6.bulkMode]
                    ]),
                    _hoisted_79
                  ])
                ]),
                _createVNode("div", _hoisted_80, [
                  (!_ctx.cheat6.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_81, [
                        _hoisted_82,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          id: "cheat6-user",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.cheat6.invoice_no = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.cheat6.invoice_no]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.cheat6.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_83, [
                        _hoisted_84,
                        _withDirectives(_createVNode("input", {
                          type: "number",
                          id: "cheat6-user",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.cheat6.nominal = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.cheat6.nominal]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.cheat6.bulkMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_85, [
                        _hoisted_86,
                        _withDirectives(_createVNode("textarea", {
                          id: "cheat6-bulk",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.cheat6.bulk = $event)),
                          rows: "5"
                        }, null, 512), [
                          [_vModelText, _ctx.cheat6.bulk]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.cheat6Submit && _ctx.cheat6Submit(...args)))
                    }, "Submit")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}